import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { TWikiFile } from '@/types/brandWiki';
import {
  IDataSourceInstance,
  ISocialDataSourceInstance,
} from '@/types/settings.ts';

export type TState = {
  sourcesOrder: number[];
  wikiFiles: TWikiFile[];
  webSite: IDataSourceInstance;
  socialDataSources: ISocialDataSourceInstance[];
};

const initialState: TState = {
  sourcesOrder: [1, 2, 3, 4],
  wikiFiles: [],
  webSite: { id: '', url: '' },
  socialDataSources: [],
};

type TActions = {
  setSourcesOrder: (sourcesOrder: number[]) => void;
  setWikiFiles: (wikiFiles: TWikiFile[]) => void;
  addWikiFile: (wikiFile: TWikiFile) => void;
  removeWikiFile: (wikiFile: TWikiFile) => void;
  setWebSite: (webSite: IDataSourceInstance) => void;
  setSocialDataSources: (
    socialDataSources: ISocialDataSourceInstance[]
  ) => void;
  resetDataSources: () => void;
};

type TStore = TState & TActions;

const useWikiStore = create<TStore>()(
  immer(
    persist(
      (set) => ({
        ...initialState,

        resetDataSources: () => {
          set((state) => {
            state.webSite = initialState.webSite;
            state.socialDataSources = [];
          });
        },
        setSocialDataSources: (socialDataSources) => {
          set((state) => {
            state.socialDataSources = socialDataSources;
          });
        },
        setWebSite: (webSite) => {
          set((state) => {
            state.webSite = webSite;
          });
        },
        addWikiFile: (wikiFile) => {
          set((state) => {
            state.wikiFiles.push(wikiFile);
          });
        },
        removeWikiFile: (wikiFile) => {
          set((state) => {
            state.wikiFiles.splice(
              state.wikiFiles.findIndex(
                (wf) => wf.fileName === wikiFile.fileName
              ),
              1
            );
          });
        },
        setWikiFiles: (wikiFiles) => {
          set((state) => {
            state.wikiFiles = wikiFiles;
          });
        },
        setSourcesOrder: (sourcesOrder) => {
          set((state) => {
            state.sourcesOrder = sourcesOrder;
          });
        },
      }),
      {
        name: 'wiki',
      }
    )
  )
);

export default useWikiStore;
